// Shared helpers for entries across the app.
// Order matters: STATUS_META keys drive the order of the Daily Log status dropdown.
export const STATUS_META = {
  next_appointment:        { label: "Next Appointment",                       tone: "slate",   sheet: "Daily Log",           short: "Next Appt" },
  ongoing_treatment:       { label: "Ongoing Treatment",                      tone: "sky",     sheet: "Follow-ups",          short: "Ongoing" },
  followup_pending_other:  { label: "Follow-up for pending/other treatment",  tone: "orange",  sheet: "Follow-ups",          short: "Follow-up" },
  treatment_completed:     { label: "Treatment Completed",                    tone: "emerald", sheet: "Completed Treatment", short: "Completed" },
  cancelled_no_show:       { label: "Cancelled / No Show",                    tone: "amber",   sheet: "Follow-ups",          short: "Cancelled" },
  lab_work:                { label: "Lab Work",                               tone: "violet",  sheet: "Lab Work",            short: "Lab" },
};

export const TONE_CLASSES = {
  slate:   "bg-slate-100 text-slate-700 border-slate-200",
  emerald: "bg-emerald-50 text-emerald-700 border-emerald-100",
  sky:     "bg-sky-50 text-sky-700 border-sky-100",
  amber:   "bg-amber-50 text-amber-700 border-amber-100",
  violet:  "bg-violet-50 text-violet-700 border-violet-100",
  orange:  "bg-orange-50 text-orange-700 border-orange-100",
};

export function fmtDate(iso) {
  if (!iso) return "—";
  const d = /^\d{4}-\d{2}-\d{2}$/.test(iso) ? new Date(iso + "T00:00:00") : new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" });
}
export function fmtDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString(undefined, {
    day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
  });
}
export function todayIso() {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}
